import { AppPlatform } from "@/api/privateRequests/user/appWaitlist";
import { useVisitorCountry } from "@/features/WingsCup/useWingsCup";

import { detectPlatform } from "./detectPlatform";

/** Where the Android open beta is on Google Play. Add a country as it opens. */
export const ANDROID_BETA_COUNTRIES = ["DK", "NO", "SE", "TR", "CZ"];

/** "beta" links to the Play listing; "waitlist" is the early access signup. */
export type AppOffer = "beta" | "waitlist";

/**
 * What the app promo offers a visitor: the Android beta to Android phones in a
 * beta country, the waitlist to everyone else. Null for an Android phone whose
 * country is still loading, so the banner doesn't swap once it answers.
 */
export const resolveAppOffer = (
  platform: AppPlatform | null,
  countryCode: string,
): AppOffer | null => {
  if (platform !== "android") return "waitlist";
  if (!countryCode) return null;
  return ANDROID_BETA_COUNTRIES.includes(countryCode.toUpperCase())
    ? "beta"
    : "waitlist";
};

/** resolveAppOffer for the current visitor. */
export const useAppOffer = (): AppOffer | null =>
  resolveAppOffer(detectPlatform(), useVisitorCountry());
